import config from '@services/config';

const baseUrl = `${config.host}/excel/live`;
import qs from 'qs';

export const exportFile = {
	// 超管导出授权记录
	exportAuthorization(params) {
		return `${baseUrl}/authorizationExport?${qs.stringify(params)}`;
	},
	// 超管导出用户
	exportUser(params) {
		return `${baseUrl}/userExport?${qs.stringify(params)}`;
	},
	// 观看奖励导出
	watchAwardExport(activityId, params) {
		return `${baseUrl}/watchAwardExport/${activityId}?${qs.stringify(params)}`;
	},
	// 投票记录导出
	voteExport(voteId) {
		return `${baseUrl}/voteExport/${voteId}`;
	},
	// 抽奖参与记录导出
	joinUserExport(activityId) {
		return `${baseUrl}/lottery/joinUserExport/${activityId}`;
	},
	// 抽奖中奖导出
	winUserExport(activityId, userName, awardName, expiryStatus) {
		return `${baseUrl}/lottery/winUserExport/${activityId}?userName=${userName}&awardName=${awardName}&expiryStatus=${expiryStatus}`;
	},
	// 签到列表导出
	signUserExport(signActivityId) {
		return `${baseUrl}/signUserExport/${signActivityId}`;
	},
	// 账单收益导出
	fundDetailExport(params) {
		return `${baseUrl}/fundDetailExport?${qs.stringify(params)}`;
	},
	// 钱包收益导出
	walletDetailExport(params) {
		return `${baseUrl}/wallet/fundList?${qs.stringify(params)}`;
	},
	// 营销账单导出
	markingDetailExport(params) {
		return `${baseUrl}/marketing/fundDetailExport?${qs.stringify(params)}`;
	},
	// 付费下载名单导出 -- 云摄影
	payDownloadUserExport(activityId, mobPhone) {
		return `${baseUrl}/payDownloadUserExport/${activityId}?mobPhone=${mobPhone}`;
	},
	// 地区统计导出
	regionStatistExport(activityId) {
		return `${baseUrl}/regionStatistExport/${activityId}`;
	},
	// 付费观看名单导出 -- 云摄影
	payWatchUserExport(activityId) {
		return `${baseUrl}/payWatchUserExport/${activityId}`;
	},
	// 邀请榜单导出
	inviteListExport(activityId) {
		return `${baseUrl}/inviteListExport/${activityId}`;
	},
	// 打赏榜单导出
	rewardListExport(activityId) {
		return `${baseUrl}/rewardListExport/${activityId}`;
	},
	// 邀请明细导出
	inviteListByUserExport(activityId, userId) {
		return `${baseUrl}/inviteListByUserExport/${activityId}/${userId}`;
	},
	// 报名表导出
	surveyAnswerExport(activityId, surveyId) {
		return `${baseUrl}/surveyAnswerExport?activityId=${activityId}&surveyId=${surveyId}`;
	},
	// 报名表导出-合集
	surveyAnswerGatherExport(gatherId, surveyId) {
		return `${baseUrl}/gather/surveyAnswerExport?gatherId=${gatherId}&surveyId=${surveyId}`;
	},
	// 观看列表导出
	watchUserExport(activityId) {
		return `${baseUrl}/watchUserExport/${activityId}`;
	},
	// 评论列表导出
	commentExport(activityId, type, nickname, check) {
		return `${baseUrl}/commentExport/${activityId}?type=${type}&nickname=${nickname}&check=${check}`;
	},
	// 白名单列表导出
	whiteCodeExport(activityId, isUsed) {
		return `${baseUrl}/whiteCodeExport/${activityId}/${isUsed}`;
	},
	// 新版问卷报名表导出
	answerReportExport(surveyId, activityId, auditStatus) {
		return `${config.host}/excel/shop/survey/export/${surveyId}/live/${activityId}?auditStatus=${auditStatus}`;
	},
	// 新版问卷报名表导出-合集
	answerReportGatherExport(surveyId, gatherId, auditStatus) {
		return `${config.host}/excel/shop/survey/export/${surveyId}/gather/${gatherId}?auditStatus=${auditStatus}`;
	},
	// 合集观看列表导出
	gatherWatchListExport(gatherId) {
		return `${baseUrl}/gather/watchUserExport/${gatherId}`;
	},
	// 合集白名单导出
	gatherWhiteCodeExport(gatherId, isUsed) {
		return `${baseUrl}/gather/whiteCodeExport/${gatherId}/${isUsed}`;
	},
	// 新版观看列表导出
	watchListExportNew(activityId) {
		return `${baseUrl}/watch-user/${activityId}`;
	},
	// 活动数据-投票导出
	activityDataVoteExport(activityId, voteId, numOrName) {
		return `${baseUrl}/voteOptionExport/${activityId}?voteId=${voteId}&numOrName=${numOrName}`;
	},
	// 手机号白名单
	phoneWhiteExport(activityId, searchText, isUsed) {
		const status = isUsed == '1' ? 'used' : 'unUsed';
		return `${baseUrl}/mobWhiteExport/${status}/${activityId}?searchText=${searchText}`;
	},
	// 预热页数据统计用户列表
	preheatUserExport(id, inviter) {
		return `${baseUrl}/preheat/user-list/${id}?inviteUserNickname=${inviter}`;
	},
	preheatTotalExport(activityId) {
		return `${baseUrl}/preheat/export-total/${activityId}`;
	},
	/*******    互动区导出    ********/
	// 小游戏导出
	gameExport(activityId, gameId, prizeType, gameType, status, winNo) {
		return `${baseUrl}/gameParticipant/${activityId}?gameId=${gameId}&prizeType=${prizeType}&gameType=${gameType}&status=${status}&winNo=${winNo}`;
	},
	// 转盘导出
	luckWheelExport(activityId, type, wheelActivityId, result, verdictStatus, winNo, status) {
		return `${baseUrl}/wheel/${activityId}?type=${type}&wheelActivityId=${wheelActivityId}&result=${result}&verdictStatus=${verdictStatus}&winNo=${winNo}&status=${status}`;
	},
	// 答题导出
	answerExport(activityId, guessActivityId, result, verdictStatus, winNo) {
		return `${baseUrl}/guess/${activityId}?guessActivityId=${guessActivityId}&result=${result}&verdictStatus=${verdictStatus}&winNo=${winNo}`;
	},
	// 推广员
	reseller(activityId) {
		return `${baseUrl}/reseller/${activityId}`;
	},
	// 订阅详情导出
	subscribeDetail(activityId, returnVisit) {
		return `${baseUrl}/subscribeDetail/${activityId}?returnVisit=${returnVisit}`;
	},
	// 直播间数据导出
	liveDataExport(activityId, title, orderBy, createUserId) {
		return `${baseUrl}/activityStat?activityId=${activityId}&title=${title}&orderBy=${orderBy}&createUserId=${createUserId}`;
	},
	// 操作日志导出
	logRecordExport(params) {
		return `${baseUrl}/logRecord?${qs.stringify(params)}`;
	},
	// 推广员导出
	extensionAgent(isTotal, checkTime, mobPhone, isDisabled) {
		return `${baseUrl}/reseller/list?isTotal=${isTotal}&checkTime=${checkTime}&mobPhone=${mobPhone}&isDisabled=${isDisabled}`;
	},
	// 投票详情导出
	VoteForDetails(optionId) {
		return `${baseUrl}/user/option/${optionId}`;
	},
	// 名片列表导出
	businessCardList(activityId) {
		return `${baseUrl}/businessCardList/${activityId}`;
	},
	// 手捧花活动数据导出
	weddingBouquetList(activityId, weddingBouquetId) {
		return `${baseUrl}/weddingBouquetList/${activityId}?weddingBouquetId=${weddingBouquetId}`;
	},
	// 用户管理-观看记录导出
	watchUserList(loginUserId, userId, activityStr) {
		return `${baseUrl}/userManage/watch-user/${loginUserId}/${userId}?activityStr=${activityStr}`;
	},
	// 用户管理导出
	userManageList(params) {
		return `${baseUrl}/um/export?${qs.stringify(params)}`;
	},
	// 华天定制导出相关
	huatianCustomExport(activityId) {
		return `${baseUrl}/ht-user/${activityId}`;
	},
	// 评论管理导出
	commentManageList(params) {
		return `${baseUrl}/um/comment/export?${qs.stringify(params)}`;
	},
	// 福袋参与人导出
	exportBlessingBag(activityId, phone, blessId) {
		return `${baseUrl}/bless/joinUserExport/${activityId}?${qs.stringify({ phone, blessId })}`;
	},
	// 福袋中奖人导出
	exportBlessingLottery(activityId, params = {}) {
		return `${baseUrl}/bless/winUserExport/${activityId}?${qs.stringify(params)}`;
	},
	// 条件抽奖/幸运抽奖中奖人导出
	exportConditionLottery(activityId, userName, awardName, expiryStatus) {
		return `${baseUrl}/conditional-lottery/winUserExport/${activityId}?userName=${userName}&awardname=${awardName}&expiryStatus=${expiryStatus}`;
	},
	// 白名单模板导出
	exportWhiteTemplate(activityId) {
		return `${baseUrl}/downloadTemplate/${activityId}`;
	},
	// 合集白名单模板导出
	exportGatherWhiteTemplate(gatherId) {
		return `${baseUrl}/downloadTemplateByGather/${gatherId}`;
	},
};
